import React, { useRef, useEffect } from "react"
import { DataGrid, Button, Template } from "devextreme-react"
import {
  Column,
  Button as GButton,
  Editing,
  StateStoring,
  SearchPanel,
  GroupPanel,
  RequiredRule,
  ColumnChooser,
  ColumnFixing,
  Grouping,
  Pager,
  HeaderFilter,
  FilterPanel,
  FilterRow,
  Scrolling,
} from "devextreme-react/data-grid"
import notify from "devextreme/ui/notify"
import { connect } from "react-redux"
import { FaFileAlt } from "react-icons/fa"

import { extractDataStore } from "../shared/ConcurStore"
import { updateExtracts } from "../operations/concur"
import { PageTitle } from "../shared/StyledComponents"
import { hasAccessTo } from "../../authentication"
import { dashboardSelectors } from "../../../state/ducks/dashboard"
import ItemScheduler from "../shared/ItemScheduler"
import SEO from "../../seo"
import { faCloudDownloadAlt } from "../shared/icons"

const Extracts = ({ navigate, refreshUuid }) => {
  const extractsGrid = useRef(null)

  useEffect(() => {
    extractsGrid.current.instance.refresh(true)
  }, [refreshUuid])

  const refreshExtractGridClickHandler = () => {
    extractsGrid.current.instance.refresh(true)
  }

  const updateExtractClickHandler = async () => {
    try {
      await updateExtracts()
      notify("Updating extract list was queued successfully.", "success")
    } catch (error) {
      notify(`Updating extract list was failed: ${error.message}`, "error")
    }
  }

  const gridRowClickHandler = e => {
    navigate(`${e.data.id}/jobs`)
  }
  const jobButtonClickHandler = e => {
    navigate(`${e.row.data.id}/jobs`)
  }

  return (
    <>
      <SEO title="Concur Extracts" />
      <PageTitle icon={FaFileAlt}>Extracts</PageTitle>
      <DataGrid
        ref={extractsGrid}
        allowColumnReordering={true}
        allowColumnResizing={true}
        columnAutoWidth={true}
        columnResizingMode="widget"
        dataSource={extractDataStore}
        hoverStateEnabled={true}
        rowAlternationEnabled={true}
        onRowClick={gridRowClickHandler}
        showBorders={true}
        onToolbarPreparing={e => {
          e.toolbarOptions.items.unshift({
            location: "before",
            template: "updateExtracts",
          })
          e.toolbarOptions.items.unshift({
            location: "before",
            template: "refreshGrid",
          })
        }}
        visible={hasAccessTo("concur.extract.r")}
      >
        <Column allowSearch={true} dataField="label">
          <RequiredRule />
        </Column>
        <Column
          allowEditing={false}
          dataField="concur_Name"
          dataType="string"
        />
        <Column
          allowEditing={false}
          dataField="concur_Id"
          dataType="string"
          defaultVisible={false}
        />
        <Column dataField="isActive" dataType="boolean" filterValue={true} />
        <Column type="buttons" showInColumnChooser={false}>
          <GButton name="delete" />
          <GButton name="edit" />
          <GButton
            name="jobs"
            icon="arrowright"
            onClick={jobButtonClickHandler}
          />
        </Column>
        <ColumnChooser
          allowSearch={true}
          enabled={true}
          height="400"
          mode="select"
        />
        <ColumnFixing enabled={true} />
        <Editing
          mode="form"
          useIcons={true}
          allowDeleting={hasAccessTo("concur.extract.d")}
          allowUpdating={hasAccessTo("concur.extract.u")}
        />
        <FilterPanel visible={true} />
        <FilterRow visible={true} />
        <Grouping contextMenuEnabled={true} />
        <GroupPanel visible={true} />
        <HeaderFilter allowSearch={true} visible={true} />
        <Pager
          visible={true}
          allowedPageSizes={[10, 20, 50, 100]}
          showPageSizeSelector={true}
          showNavigationButtons={true}
          showInfo={true}
        />
        <Scrolling showScrollbar="always" />
        <SearchPanel width={250} visible={true} />
        <StateStoring
          enabled={true}
          type="localStorage"
          storageKey="concur-lists"
        />
        <Template name="refreshGrid">
          <Button icon="refresh" onClick={refreshExtractGridClickHandler} />
        </Template>
        <Template name="updateExtracts">
          <Button
            elementAttr={{ id: "updateExtracts" }}
            icon={faCloudDownloadAlt}
            text="Update Extracts"
            visible={hasAccessTo("concur.extract.refresh")}
            onClick={updateExtractClickHandler}
          />
        </Template>
      </DataGrid>
      <ItemScheduler
        items={[
          {
            body: null,
            method: "POST",
            target: "#updateExtracts",
            title: "update extracts",
            url: "/api/v1/concur/extracts/update",
          },
        ]}
      />
    </>
  )
}

export { Extracts }

const mapStateToProps = state => ({
  timeRange: dashboardSelectors.selectTimeRange(state),
  refreshUuid: dashboardSelectors.selectAutoRefreshUuid(state),
})
export default connect(mapStateToProps, null)(Extracts)
